/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/Steps/FirstRunExperienceCreateGitHubPullRequestStep.Props" />
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { IBoardInfo } from "Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/FirstRunExperiencePanel.Props";
import { IFirstRunExperienceStepBasicProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/Steps/FirstRunExperienceStep.Props";

export interface IFirstRunExperienceCreateGitHubPullRequestStepProps extends IFirstRunExperienceStepBasicProps {
    projectId: string;
    boardInfo: IBoardInfo;
    repoNames: string[];
    workItem: WorkItem;
    onStepProcessing?: () => void;
    onStepSucceeded?: (elapsedTime: number) => void;
    onStepFailed?: (errorMessage: string, elapsedTime: number) => void;
}
